import { capitalize, decapitalize } from "../../../lib/helpers"

export default {
  capitalize,
  decapitalize
}
